// extracted by mini-css-extract-plugin
module.exports = {"comp":"ReferralNextEnd_comp__5PDQO"};